import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row g-0 p-4 pb-0" }
const _hoisted_2 = { class: "col-12 py-2" }
const _hoisted_3 = { class: "d-flex align-items-center justify-content-center" }
const _hoisted_4 = { class: "form-group pe-4 col-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "equipment-name" }, " Equipment Name ", -1 /* HOISTED */)
const _hoisted_6 = { class: "form-group col-7 mt-4" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "form-group col-12" }
const _hoisted_9 = { class: "table table-responsive-md border border-gray" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-table-header" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Equipment Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Provider Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Model Number"),
    /*#__PURE__*/_createElementVNode("th", null, "Serial Number"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1 /* HOISTED */)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading" }, null, -1 /* HOISTED */)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  class: "table-empty"
}
const _hoisted_15 = ["colspan"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h3", null, "No DMEs Found.", -1 /* HOISTED */)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 2,
  class: "table-error"
}
const _hoisted_19 = ["colspan"]
const _hoisted_20 = { class: "col-12" }
const _hoisted_21 = { class: "form-group col-12 ps-3" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { for: "non-standard-items" }, " Non Standard Items", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_ErrorMessageHandler = _resolveComponent("ErrorMessageHandler")!
  const _component_EditDmeNeededRow = _resolveComponent("EditDmeNeededRow")!
  const _component_CommentInput = _resolveComponent("CommentInput")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "DME Needed",
    "full-height": false,
    "application-id": _ctx.referral.application
  }, {
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_TypeaheadInput, {
                placeholder: "Start Typing",
                getData: _ctx.getDmesList,
                onValueChanged: _ctx.changeDmeId,
                value: _ctx.dmeId
              }, null, 8 /* PROPS */, ["getData", "onValueChanged", "value"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                class: "btn btn-md btn-primary px-3",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addDme()))
              }, "Add DME")
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("table", _hoisted_9, [
              _hoisted_10,
              (_ctx.isLoading || _ctx.isError || !_ctx.hasData)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
                    _createCommentVNode(" LOADING "),
                    (_ctx.isLoading)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.loadingCount, (i) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: i,
                            class: "table-loading"
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (i) => {
                              return (_openBlock(), _createElementBlock("td", { key: i }, _hoisted_13))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      : _createCommentVNode("v-if", true),
                    _createCommentVNode(" EMPTY "),
                    (!_ctx.isLoading && !_ctx.isError && !_ctx.hasData)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                          _createElementVNode("td", { colspan: _ctx.columns }, _hoisted_17, 8 /* PROPS */, _hoisted_15)
                        ]))
                      : _createCommentVNode("v-if", true),
                    _createCommentVNode(" ERROR "),
                    (!_ctx.isLoading && _ctx.isError)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                          _createElementVNode("td", { colspan: _ctx.columns }, [
                            _createVNode(_component_ErrorMessageHandler, {
                              title: "Contact list",
                              "try-again": _ctx.getDme
                            }, null, 8 /* PROPS */, ["try-again"])
                          ], 8 /* PROPS */, _hoisted_19)
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.dmes, (dme) => {
                    return (_openBlock(), _createElementBlock("tbody", {
                      key: dme.id
                    }, [
                      _createVNode(_component_EditDmeNeededRow, {
                        columns: _ctx.columns,
                        dme: dme,
                        "refresh-list": _ctx.getDme,
                        "patient-id": _ctx.patientId,
                        referral: _ctx.referral
                      }, null, 8 /* PROPS */, ["columns", "dme", "refresh-list", "patient-id", "referral"])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createVNode(_component_CommentInput, {
              "input-name": "referral-comments",
              result: _ctx.referral.otherDME,
              "class-list": _ctx.commentInputClass,
              "max-length": 250,
              "show-template-typeahead": _ctx.showTemplate,
              onResultUpdatedAppended: _ctx.resultUpdatedAppended,
              onResultUpdated: _ctx.resultUpdated
            }, null, 8 /* PROPS */, ["result", "class-list", "show-template-typeahead", "onResultUpdatedAppended", "onResultUpdated"])
          ])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}